import React from "react"
import { Redirect } from "react-router-dom"
import { Progress } from "@carrotfertility/carotene-core"
import useGetBenefit from "#/components/dynamic-content/hooks/useGetBenefit"
import { ProgramType } from "#/lib/carrot-api/types/Benefit"
import { Paths } from "#/utils/Paths"
import { CarrotCollectiveLandingPage } from "./CarrotCollectiveLandingPage"

export function CarrotCollectiveRoute(): JSX.Element {
  const benefitQuery = useGetBenefit()

  if (benefitQuery.isLoading) {
    return <Progress />
  }

  if (benefitQuery.data?.program?.type === ProgramType.WTW_ENGAGE) {
    return <Redirect to={Paths.HOME} />
  }

  return <CarrotCollectiveLandingPage />
}
